<!--  -->
<template>
  <div>
    <div class="head">
      <div class="head-layout">
        <img src="https://oss.cmef.com.cn/cloudExhibition/imgs/202103/338d8c90612041e4b6059d71dd8504a8.jpg"
             alt="" />
        <span style="color:#fff;font-size:26px;margin-left:10px">{{name}}</span>
      </div>
    </div>
    <div class="layout">
      <div class=""
           style="min-height: 100px">
        <div class="">
          <!-- <Breadcrumb>
            <BreadcrumbItem>首页</BreadcrumbItem>
            <BreadcrumbItem>管理</BreadcrumbItem>
            <BreadcrumbItem>证件申请</BreadcrumbItem>
          </Breadcrumb> -->
          <div class="header-tool-title">证件导入</div>
        </div>
      </div>
      <div class="layout-button">
        <div class="card">
          <span>展商证</span>
          <div class="button"
               @click="goExport(1)">点击进入</div>
        </div>
        <div class="card">
          <span>特邀嘉宾</span>
          <div class="button"
               @click="goExport(2)">点击进入</div>
        </div>
        <div class="card">
          <span>海外/港澳台认证</span>
          <div class="button"
               @click="goExport(3)">点击进入</div>
        </div>
      </div>
      <div class="layout-button"
           style="justify-content: center;">
        <div class="card">
          <span>VIP</span>
          <div class="button"
               @click="goExport(4)">点击进入</div>
        </div>
      </div>
    </div>
    <iModal title="提示"
            width="600px"
            v-model="show"
            class-name="vertical-center-modal"
            :mask-closable="false"
            @on-cancel="show=false">
      <div>
      该通道已关闭，第94届CMEF再会！
        <!-- 尊敬的展商您好,您的展商证认证已完成,如您的朋友需要参会:</br>1.请进入iCMEF小程序</br>2.登录CMEF官网:</br>中文:cmef.com.cn;</br>英文:cmef.com.cn/en</br>3.CMEF官方微信公众号进行观众预登记,谢谢!期待与您4月11日上海见! -->
        <!-- 尊敬的展商您好：恭喜您第88届CMEF展商认证已完成，更多展会信息及预告请登录CMEF官网（cmef.com.cn）或CMEF官方微信公众号获取，谢谢！期待与您10月28日深圳见！ -->
      </div>

    </iModal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      //exhibitionId:"7057da04-1d2a-437d-b791-80448f9a33db",
      name: '',
      show: false,
      date1: '5月14日', // 期待见面的日子
      date2: '2026-04-08 12:00', // 提交展商认证的日子

    }
  },
  created() {
    this.init()
  },
  computed: {
    exhibitionId() {
      return this.$route.query.exhibitionId
    },
  },
  methods: {
    ...mapActions({
      getExhibitionByIdNew: 'exhibitionModule/getExhibitionByIdNew',
    }),
    async init() {
      let data = await this.getExhibitionByIdNew(this.exhibitionId)
      if (data.name) {
        this.name = data.name
      }
    },
    goExport(index) {
      let date = new Date(this.date2).getTime()
      let now = new Date().getTime()

      if (now > date) {
        this.show = true
        return
      }
      if (index == 1) {
        this.$router.push(
          '/exhibition/export?exhibitionId=' + this.exhibitionId + '&BadgeId=1'
        )
      }
      if (index == 2) {
        this.$router.push(
          '/exhibition/export?exhibitionId=' + this.exhibitionId + '&BadgeId=2'
        )
      }
      if (index == 3) {
        this.$router.push(
          '/exhibition/export?exhibitionId=' + this.exhibitionId + '&BadgeId=3'
        )
      }
      if (index == 4) {
        this.$router.push(
          '/exhibition/export?exhibitionId=' + this.exhibitionId + '&BadgeId=4'
        )
      }
    },
  },
}
</script>
<style scoped lang='scss'>
.head {
  height: 100px;
  background: #333;
  &-layout {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    height: 100px;
    img {
      width: 70px;
      height: 70px;
    }
  }
}
.layout {
  margin: 0 auto;
  max-width: 1200px;
  min-height: 500px;

  &-button {
    display: flex;
    justify-content: space-between;
    padding: 50px;
  }
  .card {
    width: 300px;
    height: 300px;
    text-align: center;
    background: #fff;
    padding: 70px 0px;
    span {
      font-size: 28px;
      font-weight: bold;
    }
    .button {
      width: 150px;
      height: 40px;
      background: red;
      display: flex;
      align-items: center;
      color: #fff;
      justify-content: center;
      font-size: 20px;
      margin: 50px auto;
      cursor: pointer;
    }
  }
}
</style>